import { render, staticRenderFns } from "./SearchCasesList.vue?vue&type=template&id=644373ee"
import script from "./SearchCasesList.vue?vue&type=script&lang=js"
export * from "./SearchCasesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports